import { api } from "@/api";
import { syncServerClock } from "@/stores/serverClock";
import { VirtualTiming } from "./getVirtualTiming";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  VirtualSportType,
  virtualStreamPath,
} from "./virtualSportType";

export interface VirtualLeagueRound {
  leagueId: number;
  key: string;
  label: string;
  // SR season instance id (e.g. 26825) — shown as "SEZON <n>" in the VR sidebar.
  season: number;
  currentRound: number;
  totalRounds: number;
  // Rounds actually open for betting now (odds published) — usually [cr+2, cr+3],
  // fewer at season start/boundary. The UI shows exactly these weeks.
  bettingRounds: number[];
  // Match-clock timing folded into the round metadata so the countdown comes from
  // this same poll — no per-league /timing request. Null if unavailable.
  timing?: VirtualTiming | null;
}

// Per-league round info (current round + total + open betting weeks + timing) for
// the VR league tabs / week strip / countdown. The response also carries the
// server clock → sync it so every VR countdown ticks in lockstep with SR.
export const getVirtualRounds = async (
  sportType: VirtualSportType = DEFAULT_VIRTUAL_SPORT_TYPE
): Promise<VirtualLeagueRound[]> => {
  const res = await api.client.get(virtualStreamPath(sportType, "rounds"));
  syncServerClock(res.data?.serverTime);
  return res.data?.rounds ?? [];
};
